import { ContentSectionProps } from 'Storybook/components/local/ContentSection';

import { TaxStatus } from '../../@types/motCheck';

type contentSectionBaseKeys = keyof Pick<ContentSectionProps, 'contentBody' | 'imgAlt' | 'imgSrc' | 'title'>;

type contentSectionProps = { [K in contentSectionBaseKeys]: string };

export type RelatedGuidesContentType = {
  description: string;
  thumbnail: string | { alt: string; url: string };
  title: string;
  url: string;
}[];

type FilterComponentsType = {
  acf: {
    [key: string]: string;
  };
  components: {
    description: string;
    thumbnail: string;
    title: string;
    url: string;
  }[];
};

const numWordKeys = ['one', 'two', 'three', 'four', 'five', 'six'] as const;

const contentSectionKeys: (contentSectionProps)[] = numWordKeys.slice(0, 4).map((word) => ({
  contentBody: `section_${word}_body_area`,
  imgAlt: `section_${word}_image_area_alt`,
  imgSrc: `section_${word}_image_area`,
  title: `section_${word}_title`,
}));

export const getContentSectionData = (wpData: { [key: string]: string }) => {
  if (!wpData) {
    return [];
  }

  return contentSectionKeys.map((n) => ({
    contentBody: wpData[n.contentBody],
    imgAlt: wpData[n.imgAlt],
    imgSrc: wpData[n.imgSrc],
    title: wpData[n.title],
  }));
};

export const relatedGuidesNames = numWordKeys.map((n) => ({
  description: `related_guide_description_${n}`,
  thumbnail: `related_guide_image_${n}`,
  title: `related_guide_title_${n}`,
  url: `related_guide_url_${n}`,
}));

export const filterComponents = ({
  acf,
  components,
}: FilterComponentsType) => components.filter((component) => acf[component.title]);

export const getRelatedGuidesContent = (acf: Record<string, string>) => {
  if (!acf) {
    return [];
  }

  return (
    filterComponents({ acf, components: relatedGuidesNames })
      ?.map(({ description, thumbnail, title, url }) => ({
        description: acf[description],
        thumbnail: acf[thumbnail],
        title: acf[title],
        url: acf[url] || '',
      }))
  );
};

export const getCheckerStatus = (
  {
    isMotCheckRoute,
    isMotValid,
    taxStatus,
  }: {
    isMotCheckRoute?: boolean;
    isMotValid?: boolean;
    taxStatus?: TaxStatus;
  },
) => {
  const motStatus = isMotValid ? 'valid' : 'invalid';
  const checkerStatus = isMotCheckRoute ? motStatus : taxStatus;

  return checkerStatus;
};

export const TWO_WEEKS_IN_DAYS = 14;
export const MONTH_IN_DAYS = 30;
